import React from 'react';
import Campaigns from '../modules/sms/Campaigns/Campaigns';

function SMSCampaigns(){
  return <Campaigns/>
}

export default SMSCampaigns;